/**
 * Overlay
 */
export default class Overlay {

    constructor($element) {
        this.name = $element.data('overlay-name')
        this.$element = $element
        this.$closeButtons = this.$element.find('[data-overlay-dismiss]')
        this.$openButtons = $(`[data-overlay-target="${this.name}"]`)
        this.bindEventHandlers()
    }

    bindEventHandlers() {
        this.$closeButtons.on('click', e => {
            e.preventDefault()
            this.close()
        })

        this.$openButtons.on('click', e => {
            e.preventDefault()
            this.open()
        })
    }

    close()
    {
        $('body').css('overflow', 'visible')
        this.$element.fadeOut()
    }

    open()
    {
        $('body').css('overflow', 'hidden')
        this.$element.css("display", "flex")
            .hide().fadeIn();
    }

}